export default "__VITE_ASSET__CHxgaH3O__"